import React from "react";
import { NavLink, Routes, Route, Navigate, Link } from "react-router-dom";
import { Building2, ClipboardList, LogOut, ArrowLeft, ShoppingBasket } from "lucide-react";
import { Button } from "../components/ui/button";
import { Logo } from "../components/Logo";
import { canPurchase } from "./shared";
import SupplierTiles from "./SupplierTiles";
import SupplierCatalog from "./SupplierCatalog";
import OrderBoard from "./OrderBoard";
import OrderDetail from "./OrderDetail";
import "./purchases.css";

export default function PurchasesPortal({ user, logout }) {
  if (!canPurchase(user)) return <div className="p-8" data-testid="purchases-access-denied"><h1>Accesso Acquisti non abilitato</h1><p>Contatta l'amministratore per l'abilitazione.</p><Link to="/" data-testid="purchases-access-back">Torna al tuo portale</Link></div>;
  return <div className="purchases" data-testid="purchases-portal">
    <header className="acq-header"><div className="acq-brand"><Logo /><div><div className="acq-eyebrow" style={{ margin: 0 }}>Giotto Carni</div><strong className="flex items-center gap-2"><ShoppingBasket size={18} />Acquisti</strong></div></div>
      <div className="acq-header-actions"><span className="acq-muted acq-user-name" data-testid="purchases-current-user">{user.name}</span>
        {user.role !== "purchasing" && <Button variant="ghost" asChild><Link to="/" data-testid="purchases-home-link"><ArrowLeft size={16} /> Il mio portale</Link></Button>}
        <Button variant="outline" title="Esci" onClick={logout} data-testid="purchases-logout"><LogOut size={16} /></Button>
      </div></header>
    <nav className="acq-nav"><NavLink to="/purchases/suppliers" data-testid="purchases-nav-suppliers"><Building2 size={19} />Fornitori</NavLink><NavLink to="/purchases/orders" data-testid="purchases-nav-orders"><ClipboardList size={19} />Ordini e arrivi</NavLink></nav>
    <main className="acq-main"><Routes>
      <Route path="suppliers" element={<SupplierTiles />} />
      <Route path="suppliers/:sid" element={<SupplierCatalog />} />
      <Route path="orders" element={<OrderBoard />} />
      <Route path="orders/:oid" element={<OrderDetail user={user} />} />
      <Route path="*" element={<Navigate to="/purchases/suppliers" replace />} />
    </Routes></main>
  </div>;
}